import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTransactionOmni } from "../api";
import { ErrorResponse } from "./useCreateTransaction";

export const useCreateTransactionOmni = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postTransactionOmni,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TRANSACTION_OMNI"] });
      router("/order-list");
      toast.success("Success Create Transaction Omni");
    },
    onError: (error: ErrorResponse) => {
      const message =
        error?.response?.data?.message || "Failed to create transaction";
      toast.error(message);
    },
  });

  return { transaction: mutate, isPending };
};
